<template>
  <div>
    <!-- page wrapper start -->
    <div class="pg-wrapper default-page bg-white-imp">
      <app-header>
        <div class="title-bar" slot="header-foot">
          <button  class="button is-flex nav-back">
          </button>
          <h1 class="title has-text-black">Authenticate User</h1>
        </div>
      </app-header>
      <main class="content-wrapper">
        <section class="section section-content">
          <div class="container">
            <div class="columns justify-content-center">
              <div class="column is-8-tablet">
                <div class="verify-token">
                  <loading v-if="showLoading"></loading>
                  <p :class="'text-center ' + (showLoading ? '': 'loaded')" v-text="msg"></p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <app-footer></app-footer>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import LocationApis from '@/Components/Controllers/LocationApis';
import OrderHistoryApis from '@/Components/Controllers/OrderHistoryApis';
import CartApis from '@/Components/Controllers/CartApis';
import UserApis from '@/Components/Controllers/UserApis';
import LoginApis from '@/Components/Controllers/LoginApis';

export default {
  name: 'SignUpAuthenticate',
  data() {
    return {
      msg: 'Please wait while we are processing...',
      location: {},
      showLoading: true,
    };
  },

  computed: {
    ...mapGetters({
      vg_guestLandedQueries: "location/guestLandedQueries",
      vg_businessProfile: "businessprofile/detail", 
      vg_businessLoyality: "businessprofile/businessLoyality",
    })
  },

  mounted() {

    // If user is already logged in stop token verification
    if(this.$store.getters.getLoggedInUserToken){
      return this.$router.push({ 
        name: 'HomePage', 
        params: {  business_slug: this.$route.params.business_slug } 
      });
      // this.msg = 'Sorry you are already logged in.';
      // this.showLoading = false;
      // return;
    }

    let token = this.$route.query.token;
    if(token){
      // if(this.$route.query['hide-map'] == 'true'){
      //   this.va_setLocationQueries({
      //     'hide-map': true
      //   })
      // }
      // This will replace existing user and logged in the current token user
     this.loginWithToken(token); 
    } else {
      this.$router.push({ 
        name: 'HomePage', 
        params: {  business_slug: this.$route.params.business_slug } 
      });
    }
  },

  methods: {


    /**
     * Login via token, clear if  user logged in
     */
    async loginWithToken(token) {
      const self = this;
      let res = await LoginApis.loginWithToken({ token: token });
      if(res.status != 200){
        this.msg = res.response.data.msg;
        this.showLoading = false;
        setTimeout(function() {
          self.msg = 'Redirecting to homepage.';
          self.$router.push({ 
            name: 'HomePage', 
            params: {  
              business_slug: self.$route.params.business_slug 
            } 
          })
        }, 2000)
      } else {
        this.msg = 'Token Verified. Logging in...';
        // Remove existing data
        await this.$store.dispatch("REMOVE_APP_DATA");
        // Set new user values
        await this.$store.dispatch("SET_USER_TOKEN", res.data.payload.token);
        await this.$store.dispatch("SET_USER_DETAILS", res.data.payload);
        this.$store.dispatch('SET_VISITOR_DETAILS', {
          ageVerify: true,
          dob: '',
          province: '',
          remember: false,
        });   
        // Fetch order history
        // let orderHistory = await OrderHistoryApis.fetch(1);
        // if(orderHistory.status == 200) {
        //   this.va_setAllOrders(orderHistory.data.payload);
        // }
        // Fetch user fav products
        //UserApis.fetchFavProducts();
        // Fetch user fav locations
        //UserApis.fetchFavLocations();
        // await this.fetchLocation(this.$route.params.locationId);
        // if(!_.isEmpty(this.location) && this.location.id != ''){
        //   await CartApis.locationCart(this.location.id, this.getCartFullUrl());
        // }

        // If not setup try it, signup hits loyality in it
        if(this.vg_businessLoyality.id && this.vg_businessLoyality.is_active) {

          let loyaltyJoinRes = await this.va_joinUserOnLoyalityProgram({
            user_id: res.data.payload.id,
            business_id: this.vg_businessProfile.id,
            referral_key: this.$route.query.referral_key ? this.$route.query.referral_key : '', // if has ref key pass it 
          })

          // For signup bonus
          if( (loyaltyJoinRes.status == 201) && (loyaltyJoinRes.data.payload.welcome_bonus > 0) ) {
            // show loyalty bonus point for signup
            bus.$emit('loyality-signup-congratulations', {
              modal: true,
              point: loyaltyJoinRes.data.payload.welcome_bonus,
              message: "Sign Up Bonus!",
            })
          }

          // For referral bonus
          if( (loyaltyJoinRes.status == 201) && (loyaltyJoinRes.data.payload.referral_bonus > 0) ) {
            // show loyalty bonus point for signup
            bus.$emit('loyality-referral-congratulations', {
              modal: true,
              point: loyaltyJoinRes.data.payload.referral_bonus,
              message: "A little something for being referred!",
            })
          }
        }

        this.msg = 'Successfully logged in...';
        this.$router.push({ 
          name: 'HomePage', 
          params: { 
            business_slug: this.$route.params.business_slug, 
          }, 
          //query: this.vg_guestLandedQueries
        })
      }
    },

    ...mapActions({
      va_loginWithToken: "auth/loginWithToken",
      va_setLocationQueries: "location/setGuestLandedQueries",
      va_setAllOrders: "orderhistory/setAllOrders",
      va_joinUserOnLoyalityProgram: "userloyalitysubscription/joinUserOnLoyalityProgram",
    })

  },
};
</script>

<style scoped>
.verify-token {
    position: relative;
}
.verify-token p {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 50px;
}
p.text-center.loaded {
  bottom: 0;
  position: relative;
  margin-top: 80px;
}
</style>